//POST /api/v1/target body(target)
//GET /api/v1/target/latest

const API_URL = process.env.REACT_APP_API_URL;

const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export async function setTarget(target) {
    const response = await fetch(`${API_URL}/api/v1/target`, {
        method: 'POST',
        headers: getAuthHeader(),
        body: JSON.stringify({ target })
    });
    return response;
}

export async function getLatestTarget() {
    const response = await fetch(`${API_URL}/api/v1/target/latest`, {
        method: 'GET',
        headers: getAuthHeader()
    });
    return response;
}
